import { useState } from "react";


import { Button } from "@mosanic/fields";
import Input from '@mosanic/fields/Input';
import { AdvancedLabel, Card, InputGroup, InputGroupItem } from "@mosanic/items";
import { capitalizeFirst } from "@util/Text";
import { useForm } from "react-hook-form";

import { useSendOne } from "@mosanic/components/Mail";
import { getTicketData } from "./getTicketData";


const NewTicket = ({data, plan = null, userData = null, cta, small = false}) => {
  if(!data) data= getTicketData('default')

  const { handleSubmit, control, watch, formState: { errors, isValid } } = useForm({mode: 'all'});
	const inputProps = {control, errors}

  const [mailSend, setMailSend] = useState(false)
  const [sendMail, sendData, sendLoading] = useSendOne()
  // const [sendMail, [sendData, loading, error]] = useLazyQuery('mailSendOne', SEND_MAIL)
  



  const proPlan = ['enterprise', 'pro'].includes(plan);

  const ticketType = watch().type;
  const mainCategories = "pre-sale|membership|addons|account|support|bug|other";

  const subTypeOptions = () => {
    switch(ticketType){
      case "pre-sale": return "enterprise|combined plan|feature info|other"
      case "membership": return "upgrade|downgrade|plans|other"
      case "addons": return "localization|user roles|connections|other"
      case "account": return "login|signup|termination|users|other"
      case "support": return "documentation|user guide|topic|priority bug"
      case "bug": return "in builder|in inspector|in cms|in admin|other place"
      case "other": return "feature request|not included"
      default: return "Select a main category first."
    }
  }

  const onSubmit = async (data) => {
		// setDisabled(true);
    const subject = `[Ticket received]: ${data?.type} ${data?.subType}  (${data?.priority})`;
    const from = userData?.firstName ? `${userData?.firstName} ${userData?.lastName}` : data?.fullName
    const to = userData?.email ? userData.email : data?.email

    sendMail({
      subject: `Hi ${from}, Mosanic has received your ticket.`, 
      to, 
      preHeader: "👀 Keep an eye on your mail, we will get back to you! .", 
      subHeader: "✔️ Ticket submitted.", 
      mainHeader: "We've received your ticket successfully.", 
      mainText: `The content we received is as follows: \n
      Category: ${data?.type} ${data?.subType} \n
      Subject: ${data?.subject} \n 
      Text: ${data?.message} \n
      We will get back to your shortly! \n
      Kind regards,\n
      -The Mosanic Team`
    })

    sendMail({
      subject, 
      to: 'support@mosanic.io', 
      preHeader: `New ticket from: ${from}`, 
      subHeader: `Priority: ${data?.priority}`, 
      mainHeader: data.subject, 
      mainText: `Msg: ${data?.message}  \n
      Category: ${data?.type} ${data?.subType} \n
      From: ${from} \n
      Email: ${to} `,
      simple: true
    })
    setMailSend(true)
	};
  return ( 
        <Card>
            <h3>
              {data?.ticketHeader}
            </h3>
            <AdvancedLabel span
              label={data?.ticketIntro}
              helpText={data?.ticketHelp}
            />
            <form disabled={mailSend} onSubmit={handleSubmit(onSubmit)}>
              <InputGroup>
                <Input
                  name="subject" label={data?.subject} type="text" fullWidth {...inputProps} required
                  rules={{required: `${data?.subject} is required.`}}
                />
                {(proPlan && data?.type != 'termination') && (
                  <Input
                    name="priority" type="select" label="Ticket priority 🚨" fullWidth {...inputProps} required
                    options={"critical|high|normal|low|instant chat".split('|')}
                    rules={{required: `Define the priority please.`}}
                  />
                )}
                {data?.type != 'termination' && (
                  <>
                  <Input
                    name="type" type="select" label={small ? "Category" : "Ticket category"} {...inputProps} required
                    rules={{required: `${data?.subject} category is required.`}}
                    options={mainCategories.split('|')}
                    clearable={false}
                  />
                  <Input
                    name="subType" type="select" label={small ? "Sub" : `${ticketType ? capitalizeFirst(ticketType) : ''} sub category`} {...inputProps} required
                    rules={{required: `${ticketType} sub category is required.`}}
                    options={subTypeOptions()?.split('|')}
                    clearable={false}
                  />
                  </>
                  
                )}

                <Input
                  name="message" label="Message" type="textarea" fullWidth {...inputProps} 
                />

                {(!plan && !userData?.email) && (
                  <>
                  <InputGroupItem fullWidth>
                    <h4>Contact details</h4>
                  </InputGroupItem>
                  <Input
                    name="fullName" fullWidth type="text" label="Full name" {...inputProps} required
                    rules={{required: `Please provide your name.`}}
                  />
                  <Input
                    name="email" fullWidth type="email" label="E-mail" {...inputProps} required
                    rules={{required: `Email field is required since we otherwise wouldn't be able to contact you.`}}
                  />
                  </>
                )}

                <Button type="submit" wrap disabled={!isValid || mailSend} label={
                    sendLoading ? 'Loading' :
                    mailSend ? 'Ticket send' :
                    'Submit'
                }
                />

              </InputGroup>
            </form>
            {mailSend ? 
              <AdvancedLabel>
                Thanks! <br/>
                We&apos;ve received your ticket and will git back to you shortly. <br/>
                Keep an eye on your email for our reply.
              </AdvancedLabel>
            : null}
        </Card>
  );
}

export default NewTicket;
